import React, { useState, useEffect } from 'react';
import PresentationSliding from './PresentationSliding';
import PresentationStatic from './PresentationStatic';

const Presentation = () => {
  // Window is undefined (0) during build due to Gatsby issue; this code snippet is a workaround to fix that. Check Gatsby debugging HTML builds.
  if (typeof window === `undefined`) {
    return (<></>);
  }
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    if (typeof window === `undefined`) {
      return <></>;
    }
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [width]);

  return (
    <>
      <div style={ width > 992 ? { display: "block" } : { display: "none" } }>
        <PresentationSliding />
      </div>
      <div style={ width > 992 ? { display: "none" } : { display: "block" } }>
        <PresentationStatic />
      </div>
    </>
  );
};

export default Presentation;
